/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { SalesStatus } from '@msdyn365-commerce/retail-proxy';

export enum RefinerSourceType {
    Origin = 1,
    CreatedDate = 2,
    OrderStatus = 3
}

export enum DateRefinerOptionItem {
    LastSevenDays = 0,
    LastThirtyDays = 1,
    LastThreeMonths = 2,
    LastSixMonths = 3,
    Customized = 999
}

export enum OrderStatusRefinerOptionItem {
    Created = SalesStatus.Created,
    Delivered = SalesStatus.Delivered,
    Invoiced = SalesStatus.Invoiced,
    Canceled = SalesStatus.Canceled
}

export interface IDateRange {
    startDate?: Date;
    endDate?: Date;
}
